import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Proof() {
  const timeline = [{
    day: 'Día 3',
    desc: 'La cara y los párpados se ven más descansados.'
  }, {
    day: 'Día 5',
    desc: 'El tránsito lento se normaliza.'
  }, {
    day: 'Día 7',
    desc: 'La inflamación abdominal ha bajado lo suficiente como para que tu ropa habitual se sienta cómoda otra vez.'
  }];
  return <section className="py-20 md:py-32" data-id="element-199">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-200">
        <FadeIn data-id="element-201">
          <div className="text-center mb-16" data-id="element-202">
            <h2 className="font-serif text-3xl md:text-4xl text-teal mb-4" data-id="element-203">
              Lo que cambia en 7 días
            </h2>
            <div className="w-12 h-[1px] bg-gold mx-auto" data-id="element-204"></div>
          </div>
        </FadeIn>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-[1px] before:bg-gradient-to-b before:from-transparent before:via-teal/20 before:to-transparent" data-id="element-205">
          {timeline.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-206">
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-207">
                {/* Marker */}
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-white bg-sage text-teal shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-208">
                  <div className="w-2 h-2 bg-gold rounded-full" data-id="element-209"></div>
                </div>

                {/* Content */}
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-xl bg-white shadow-sm border border-teal/5" data-id="element-210">
                  <h3 className="font-serif text-xl text-teal mb-2" data-id="element-211">
                    {item.day}
                  </h3>
                  <p className="text-teal/70 font-light leading-relaxed" data-id="element-212">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}